import { render, staticRenderFns } from "./TaskDetails.html?vue&type=template&id=9be12fea&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.scss?vue&type=style&index=0&id=9be12fea&prod&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./TaskDetails.vue?vue&type=style&index=2&id=9be12fea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be12fea",
  null
  
)

export default component.exports